import { createMfeComponent } from 'features/mfe/components/MfeComponent';
import type { FC } from 'react';
import type { FieldTemplate, FieldTemplateProps } from 'types/JourneysDeclarativeUI';
import { VariableSharingModal } from '../../traffic/campaigns/campaign-types/config-driven/content/custom-widgets/variable-sharing-modal/VariableSharingModal';

const FieldTemplateComponent = createMfeComponent<typeof FieldTemplate>('FieldTemplate', {
  remote: 'JourneysDeclarativeUI',
});

/**
 * Extended FieldTemplate that adds variable sharing functionality to all form fields.
 *
 * This component follows the architectural pattern:
 * 1. DeclarativeUI exports FieldTemplate (with decorator support)
 * 2. DPB extends the template by passing VariableSharingModal as decorator
 * 3. Extended template is passed back to the form
 *
 * All form fields will automatically get the variable sharing modal functionality.
 * The dmccConfig and applyVariableSharingPropagation are extracted from form context and passed to VariableSharingModal.
 */
export const ExtendedFieldTemplate: FC<FieldTemplateProps> = (props) => (
  <FieldTemplateComponent
    {...props}
    belowDecorator={(decoratorProps) => <VariableSharingModal {...decoratorProps} {...props.registry.formContext} />}
  />
);
